<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/A97PeS/tc-custom/9781426855009.jpg?1740862301686" alt="This image is the cover for the book Tamed: Barbarian King"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tamed: Barbarian King
      </h1>
      <p class="bookDescription body article font2">
        <b>A king longs for the woman he lost to another man in this forbidden romance from a <i>USA Today</i>–bestselling author.</b><br/><br/>He’s as wild as the desert, a barbarian prince, a revered leader. Long ago he loved a girl, but the power of their feelings almost destroyed them both. Now that woman, the only one he could ever love, is forbidden to him!<br/><br/>Betrothed to another, unable to bear him sons, she is unfit to be his queen. . . . But she can stop the storm that has raged in his heart since he last made her his.<br/><br/>His choice—take her as his mistress, or become the king he was born to be. . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennie Lucas
      </h2>
      
      <p class="authorDescription body article">Jennie Lucas's parents owned a bookstore and she grew up surrounded by books, dreaming about faraway lands. At twenty-two she met her future husband and after their marriage, she graduated from university with a degree in English. She started writing books a year later. Jennie won the Romance Writers of America&rsquo;s Golden Heart contest in 2005 and hasn&rsquo;t looked back since. Visit Jennie&rsquo;s website at: www.jennielucas.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a1214696